import {DefaultTheme} from "@react-navigation/native";
import * as colors from '../Theme/Colors'
import Pictos from "./picto";

export const fonts = {
    title : 'Poppins-SemiBold',
    text : 'Manrope-Medium',
    text_bold:'Manrope-Bold'
}

export const darkTheme={
    fonts : fonts,
    pictos : Pictos,
    colors : {
        ...DefaultTheme.colors,
        primary : {
            /*Blue*/
            blue1 :colors.Azure_Radiance,
            blue2 :colors.Curious_Blue,
            blue3 : colors.Dodger_Blue50,
            blue4 : colors.Dodger_Blue35,
            blue5 : colors.Dodger_Blue10,
            /*Red*/
            error : colors.Sunset_Orange,
            White : colors.Mirage
        },
        secondary :{
            /*Green*/
            green1:colors.Gossamer,
            green2 : colors.Persian_Green,
            green3:colors.Keppel25,
            /*Pink*/
            pink1:colors.Cerise_Red,
            pink2:colors.Cranberry,
            pink3:colors.French_Rose15,
            /*Orange*/
            orange1:colors.Hot_Cinnamon,
            /*YellowCode*/
            yellow1:colors.Crusta15,
            yellow2:colors.Kournikova,
            //yellow3:colors.Fuel_Yellow
        },
        tertiary:{
            /*Black*/
            black1:colors.White,
            black2:colors.White90,
            black3:colors.White80,
            black4:colors.White70,
            black5:colors.White60,
            grey1:colors.White50,
            black6:colors.White40,
            grey2:colors.White30,
            black8:colors.White25,
            black9:colors.White20,
            black10:colors.White15,
            black11:colors.White10,
            black12:colors.White4,
            black13:colors.White4,
            grey3:colors.Ebony_Clay,
        }
    }
}

export const lightTheme={
    fonts : fonts,
    pictos : Pictos,
    colors : {
        ...DefaultTheme.colors,
        primary : {
            /*Blue*/
            blue1 :colors.Blue_Ribbon,
            blue2 :colors.Dodger_Blue,
            blue3 : colors.Blue_Ribbon50,
            blue4 : colors.Blue_Ribbon35,
            blue5 : colors.Solitude,
            White : colors.White,
            /*Red*/
            error : colors.Sunset_Orange
        },
        secondary :{
            /*Green*/
            green1:colors.Keppel,
            green2 : colors.Bright_Turquoise,
            green3:colors.Polar,
            /*Pink*/
            pink1:colors.French_Rose,
            pink2:colors.Hot_Pink,
            pink3:colors.Carousel_Pink,
            /*Orange*/
            orange1:colors.Crusta,
            /*YellowCode*/
            yellow1:colors.Sunglow,
            yellow2:colors.Half_Dutch_White
        },
        tertiary:{
            /*Black*/
            black1:colors.Mirage,
            black2:colors.Black80,
            black3:colors.Black70,
            black4:colors.Black60,
            black5:colors.Black50,
            grey1:colors.Gray,
            black6:colors.Black40,
            grey2:colors.Dusty_Gray,
            black8:colors.Black30,
            black9:colors.Black20,
            black10:colors.Black15,
            black11:colors.Black10,
            black12:colors.Black7,
            black13:colors.Black4,
            grey3:colors.Porcelain,
        }
    }
}

const MyTheme ={
    ...DefaultTheme,
    light : lightTheme,
    dark:  darkTheme
}



export default MyTheme;
